import { Link } from "react-router";
import logoSCA from "@assets/events-awards/logo-sca.png";
import FooterMenuLinks from "@events-awards/EventsAwardsFooterComponents/FooterMenuLinks";
import { EVENTS_AWARDS_SCA_PATH } from "@events-awards/utils/constants";
import { SCA_FOOTER_MENU } from "@sca/components/SCAconstants";

/**
 * Component to display footer for mobile view in SCA pages
 */
const SCAFooterMobile = (): React.ReactElement => {
  return (
    <div
      className="w-full pb-2 text-center"
      data-testid="sca-footer-mobile-component"
    >
      <div className="mb-12 flex w-full flex-col items-center justify-center">
        <Link to={EVENTS_AWARDS_SCA_PATH}>
          <img
            src={logoSCA}
            alt="Singapore Corporate Awards logo"
            width={124}
            height={166}
          />
        </Link>
      </div>

      <div>
        <h3 className="mb-2 text-left font-poppins text-base font-medium">
          About Us
        </h3>

        <p className="text-left text-base leading-[1.4] text-white">
          The Singapore Corporate Awards was launched on 19 September 2005 as
          the umbrella awards for exemplary corporate governance practices for
          listed companies in Singapore. It seeks to consolidate existing awards
          while introducing new awards in the area of excellent corporate
          governance.
        </p>
      </div>

      <div className="-mx-0 mt-12 flex w-full flex-row">
        <div className="w-1/2">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Sections
          </h3>

          <FooterMenuLinks
            items={SCA_FOOTER_MENU.slice(0, 6)}
            className="space-y-4"
          />
        </div>

        <div className="w-1/2 pl-3">
          <h3 className="mb-4 text-left font-public-sans text-base font-semibold">
            Quick Links
          </h3>

          <FooterMenuLinks
            items={SCA_FOOTER_MENU.slice(6, 9)}
            className="space-y-4"
          />
        </div>
      </div>
    </div>
  );
};

export default SCAFooterMobile;
